const { palette, namedColors } = require('./palettes/palette');
const { paletteMorningHorizon, namedColorsMorningHorizon } = require('./palettes/palette-morning-horizon');
const { paletteDark, namedColorsDark } = require('./palettes/palette-dark');

module.exports = {
  palette,
  namedColors,
  paletteMorningHorizon,
  namedColorsMorningHorizon,
  paletteDark,
  namedColorsDark
};
